<div class="container">

  <div class="row mt-4">
    <h3 class="side-panel-label mb-2">Entity Details</h3>

    <div class="col-12">

      <!-- ENTITIES -->
      <div *ngFor="let entity of entityControls; let i = index" class="border p-3 mb-3 rounded">

        <div [formGroup]="entity">

          <!-- ENTITY FIELDS -->
          <div class="row">

            <!-- Entity Name -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Entity Name <sup>*</sup></label>
              <input class="form-control"
                     formControlName="entityName"
                     [ngClass]="{ 'is-invalid': entity.get('entityName')?.invalid && entity.get('entityName')?.touched }">

              <app-validation
                field="entityName"
                [form]="entity"
                [error]="{
                  required: 'Entity Name is required',
                  minLength: 'Minimum 3 characters required',
                  maxLength: 'Maximum 90 characters allowed',
                  pattern: 'Only alphabets, numbers & spaces allowed'
                }">
              </app-validation>
            </div>

            <!-- Entity Display Code -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Entity Display Code <sup>*</sup></label>
              <input class="form-control"
                     formControlName="entityDisplayId"
                     [ngClass]="{ 'is-invalid': entity.get('entityDisplayId')?.invalid && entity.get('entityDisplayId')?.touched }">

              <app-validation
                field="entityDisplayId"
                [form]="entity"
                [error]="{
                  required: 'Display Code is required',
                  minLength: 'Minimum 1 character required',
                  maxLength: 'Maximum 8 characters allowed',
                  pattern: 'Only alphabets, numbers, spaces & hyphens allowed'
                }">
              </app-validation>
            </div>

            <!-- Contact Person Name -->
            <div class="col-md-4 mb-3">
              <label class="form-label">Contact Person</label>
              <input class="form-control"
                     formControlName="contactPersonName"
                     [ngClass]="{ 'is-invalid': entity.get('contactPersonName')?.invalid && entity.get('contactPersonName')?.touched }">

              <app-validation
                field="contactPersonName"
                [form]="entity"
                [error]="{
                  minLength: 'Minimum 3 characters required',
                  maxLength: 'Maximum 50 characters allowed',
                  pattern: 'Only alphabets, numbers & spaces allowed'
                }">
              </app-validation>
            </div>

            <!-- Mobile -->
            <div class="col-md-4 mb-3">
              <label class="form-label">Mobile</label>
              <input class="form-control"
                     placeholder="91 9999999999"
                     formControlName="contactPersonMobile"
                     [ngClass]="{ 'is-invalid': entity.get('contactPersonMobile')?.invalid && entity.get('contactPersonMobile')?.touched }">

              <app-validation
                field="contactPersonMobile"
                [form]="entity"
                [error]="{
                  minLength: 'Must be 13 characters',
                  maxLength: 'Must be 13 characters',
                  pattern: 'Enter valid contact number (91 XXXXXXXXXX)'
                }">
              </app-validation>
            </div>

            <!-- Email -->
            <div class="col-md-4 mb-3">
              <label class="form-label">Email</label>
              <input class="form-control"
                     formControlName="contactPersonEmail"
                     [ngClass]="{ 'is-invalid': entity.get('contactPersonEmail')?.invalid && entity.get('contactPersonEmail')?.touched }">

              <app-validation
                field="contactPersonEmail"
                [form]="entity"
                [error]="{
                  email: 'Enter valid email ID',
                  minLength: 'Minimum 10 characters required',
                  maxLength: 'Maximum 40 characters allowed'
                }">
              </app-validation>
            </div>

          </div>

          <!-- LOCATIONS -->
          <h4 class="side-panel-label mt-4 mb-2">Locations</h4>

          <div *ngFor="let location of getLocationsArray(i).controls; let j = index"
               class="border p-3 mb-2 rounded">

            <div [formGroup]="location">

              <!-- Location Code -->
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Location Code <sup>*</sup></label>
                  <input class="form-control"
                         formControlName="locationCode"
                         [ngClass]="{ 'is-invalid': location.get('locationCode')?.invalid && location.get('locationCode')?.touched }">

                  <app-validation
                    field="locationCode"
                    [form]="location"
                    [error]="{
                      required: 'Location Code is required',
                      minLength: 'Minimum 3 characters required',
                      maxLength: 'Maximum 20 characters allowed',
                      pattern: 'Only alphabets, numbers & hyphens allowed'
                    }">
                  </app-validation>
                </div>
              </div>

              <!-- Address Block -->
              <h4 class="side-panel-label mb-2">Address</h4>

              <div formGroupName="address">
                <div class="row">

                  <div class="col-md-4 mb-3">
                    <label class="form-label">Door No</label>
                    <input class="form-control" formControlName="doorNo">
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label">Street</label>
                    <input class="form-control" formControlName="street">
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label">Area</label>
                    <input class="form-control" formControlName="area">
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label">City</label>
                    <input class="form-control" formControlName="city">
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label">Pincode</label>
                    <input class="form-control" formControlName="pincode">
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label">State</label>
                    <input class="form-control" formControlName="state">
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label">Country</label>
                    <input class="form-control" formControlName="country">
                  </div>

                </div>
              </div>

              <!-- Remove Location -->
              <div class="text-end" *ngIf="getLocationsArray(i).length > 1">
                <button class="btn btn-danger btn-sm" (click)="removeLocation(i, j)">Remove Location</button>
              </div>

            </div>

          </div>

          <!-- Add Location -->
          <button class="btn btn-outline-secondary btn-sm mb-3" (click)="addLocation(i)">
            + Add Another Location
          </button>

          <!-- Remove Entity -->
          <div class="text-end" *ngIf="entityControls.length > 1">
            <button class="btn btn-danger btn-sm" (click)="removeEntity(i)">Remove Entity</button>
          </div>

        </div>
      </div>

      <!-- Add Entity -->
      <button class="btn btn-outline-primary mb-3" (click)="addEntity()">+ Add Another Entity</button>

    </div>
  </div>

  <!-- FOOTER -->
  <div class="d-flex justify-content-end gap-2 mt-4">
    <button class="btn btn-primary" (click)="next()">Save & Next</button>
  </div>

</div>
